import VueRouter from 'vue-router';
import Dashboard from './views/pages/Dashboard.vue';
import { settingsRoutes } from './settingsRoutes';

Vue.use(VueRouter);

let routes = [
    {
        path: '/',
        component: Dashboard,
        meta: {
            title: "dashboard",
        },
        alias: '/home'
    },

    ...settingsRoutes,
];


// routes = Vue.cmsRouter.setRoutes(routes);
const dashboardRoute = {
    path: '/',
    component: Dashboard,
    meta: {
        title: "dashboard",
    },
    alias: '/home'
};
routes = [dashboardRoute,...Vue.cmsRouter.setRoutes(routes)];

const router = new VueRouter({
    routes
})

Vue.cmsRouter.setActiveRouter(router);

export default router;
